export enum EInventory {
  ACTIVE = 'ACTIVE',
  OUT_OF_STOCK = 'TEMPORARILY OUT OF STOCK',
  SOLD_OUT = 'SOLD OUT',
  COMING_SOON = 'COMING SOON',
}
